import { useTranslation } from 'next-i18next';
import { ButtonV2 } from '@bridebook/ui';
import { IconBookmark } from '@bridebook/ui/src/icons';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';

const BookmarkButton = () => {
  const { t } = useTranslation('articles');

  return (
    <SignupLink>
      <ButtonV2 size="small" variant="secondary" endIcon={<IconBookmark width={10} />}>
        {t('button.bookmark')}
      </ButtonV2>
    </SignupLink>
  );
};

export default BookmarkButton;
